import React, {Component} from 'react';
import ReactDOM from 'react-dom'
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

import { PaymentForm } from './'

class ChangePayment extends Component {
  componentDidMount(){
    const element = ReactDOM.findDOMNode(this);
      if (element != null) {
        window.scrollTo(0, this.scrollPosition)
      }
  }
  render(){
    const { translate } = this.props
    return(
      <div id="personal-information-edit-payment" >
        <div className="card card-section" id="payment">
          <div className="card-block">
            <div className="card-title">
              <h3>{translate('bank-details')}</h3>
            </div>
            <PaymentForm />
          </div>
        </div>
      </div>
    )
  }
}

const HandlerViewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
  }
}

const HandlerViewMapDispatchToProps = (dispatch) => {
  return {
  };
};
  ChangePayment = connect(
    HandlerViewMapStateToProps,
    HandlerViewMapDispatchToProps,
  )(ChangePayment);
export default ChangePayment;



// WEBPACK FOOTER //
// ./src/components/Payment/ChangePayment.js